/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：994
 */

var r = require(/* 995 */"./995/index")
var i = require(/* 2486 */"./2486")
var o = require(/* 2487 */"./2487")
var a = require(/* 2488 */"./2488")
var s = require(/* 2489 */"./2489")
var c = require(/* 2490 */"./2490/index")
function u(e) {
  var t = this.__data__ = new r(e)
  this.size = t.size
}
u.prototype.clear = i
u.prototype.delete = o
u.prototype.get = a
u.prototype.has = s
u.prototype.set = c
module.exports = u
